/*
  Version: v01
  File: CertifiedBankCardFooter_v01.tsx
  Description: Footer component split from the original CertifiedBankCard landing page.
*/

import React from 'react';
import { Col, Container, Row, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { LogoText } from './CertifiedBankCardUtility';


const versionNumber = "v02a";

export default function CertifiedBankCardFooter_v01(): React.JSX.Element {
  return (
    <footer className="py-4 border-top bg-white">
      <Container>
        <Row className="g-3 align-items-center">
          <Col md={4}>

           <Navbar.Brand href="/" className="fw-bold text-primary">
          
            {/* <div className="fw-bold text-primary">
              Certified<span style={{ color: '#082042' }}>BankCard</span>
            </div> */}

            <LogoText></LogoText>

            <div className="text-muted small">Payment Processing · Business Funding · Financial Services</div>

            </Navbar.Brand>
          </Col>


          <Col md={4} className="text-md-end">    
              <div className="cbc-legal-links">
                <Link to="/terms-of-service">Terms of Service</Link>
                <span className="mx-2 text-muted">|</span>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </div>

          </Col>

                        


          <Col md={4} className="text-md-end">
            <div className="small text-muted"> · {versionNumber}</div>
          </Col>


          
        </Row>
      </Container>
    </footer>
  );
}

/*
  File Name: CertifiedBankCardFooter_v01.tsx
  Quick Description: Footer component for the CertifiedBankCard landing page.
  Version: v01
*/
